/**
 * The eight robot colours. A player picks one on joining, no two robots
 * at a table share one, and a robot whose player named none is drawn in
 * its seat's. The server checks the pick and the client draws with it, so
 * the list lives here where both read it.
 *
 * BRIGHTER THAN THE BOARDS. They used to be picked to sit with the site's
 * own paint -- `--paint-red` and the rest in `styles.css`, which are the
 * same three values -- and that is a palette for flat chrome on a plain
 * ground. A robot is a small shape on printed board art, and against a
 * busy tile a muted colour reads as part of the floor.
 *
 * The two ends are the awkward ones and are handled rather than lifted
 * with the rest. The seventh stays the darkest of the eight -- it is the
 * "black" robot -- but slate rather than near-black, which was a hole in
 * dark board art. The eighth goes the other way, to near-white: it is
 * lighter than the floor instead of darker, which works because the robot
 * art is drawn with a dark outline and that is what separates it from the
 * ground.
 */
export const ROBOT_COLOURS = [
    '#d9503f', '#3d86ad', '#f2c94c', '#57a06a',
    '#9a70c4', '#e5842c', '#4b5058', '#d5dbcf',
];
/** A seat's colour, for a robot whose player row names none. */
export function seatColour(seat) {
    return ROBOT_COLOURS[(seat - 1) % ROBOT_COLOURS.length];
}
